import React, {useEffect, useState} from 'react';
import {Files} from '../../../FW/Models/File';
import Player from '../../../Components/Video/Player';
import VideoFileGlobalPlayer from '../../../Components/Video/VideoFileGlobalPlayer';

export default function MediaLibraryCarousel(props) {
  const [currentFile, setCurrentFile] = useState(0);
  const [fs, setFs] = useState([]);

  useEffect(() => {
    let library = FW.store.get('section-' + props.section.get('id') + '-library');
    let options = props.section.prop('options');
    console.log('OPTIONS: ', options);
    const f = new Files();
    f.addQuery({
      media_libraries: [library.get('id')],
      categories: options.default_category_id
    });
    if (library.get('site_id') !== FW.store.get('site').get('id')) {
      f.setSite(library.get('site_id'));
    }
    f.sortByField('id', 'ASC');
    f.getAll({excludeRelations: true}).then(() => {
      setFs(f);
    });
  }, []);

  return <div>
    {fs.length > 0 ? <>
      <div style={{width: '10%', display: 'inline-block'}}>
        {currentFile !== 0 ? <span className="fa fa-chevron-left" style={{fontSize: 45, position: 'relative', top: -185, cursor: 'pointer', padding: 10}} onClick={()=>{setCurrentFile(currentFile - 1)}}></span> : null}
      </div>
      <div style={{width: '80%', height: 400, display: 'inline-block'}}>
        <VideoFileGlobalPlayer file={fs.at(currentFile)} />
      </div>
      <div style={{width: '10%', display: 'inline-block'}}>
        {currentFile < (fs.length - 1) ? <span className="fa fa-chevron-right" style={{fontSize: 45, position: 'relative', top: -185, cursor: 'pointer', padding: 10}} onClick={()=>{setCurrentFile(currentFile + 1)}}></span> : null}
      </div>
    </> : null}
  </div>

}
